import { AuthState } from '../interfaces/auth.interface';

export const initialAuthState: AuthState = {
  user: null,
  loading: false,
  error: null,
};

export const AUTH_FEATURE_KEY = 'auth';

export const AUTH_STORAGE_KEYS = {
  accessToken: 'access_token',
  refreshToken: 'refresh_token',
  tempToken: 'temp_token',
} as const;

export const AUTH_API_ENDPOINTS = {
  login: 'staff/log-in',
  subscribeToNewsletter: 'staff/subscribe-to-newsletter',
  signup: 'staff/sign-up',
  logout: 'staff/log-out',
  onboarding: 'onboarding',
  onboardingComplete: 'onboarding/complete',
  forgotPassword: 'staff/forgot-password',
  resetPassword: 'staff/reset-password',
  validateResetToken: 'staff/validate-reset-password-token',
  validateNewPassword: 'staff/validate-reset-password',
};
